import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const DealershipHeader = ({ dealership }) => {
  // Enhanced CI color application with better visibility
  const headerStyle = dealership?.ciPrimaryColor ? {
    background: `linear-gradient(135deg, ${dealership?.ciPrimaryColor}20 0%, ${dealership?.ciSecondaryColor || dealership?.ciPrimaryColor}10 100%)`
  } : {};

  return (
    <header className="bg-card border-b border-border" style={headerStyle}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Grid Balance Logo - Top Section */}
        <div className="flex items-center justify-center mb-6 pb-4 border-b border-border/50">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-lg overflow-hidden bg-muted flex items-center justify-center">
              <Image
                src="/assets/images/IMG-20251119-WA0004-1767439147758.jpg"
                alt="Grid Balance Logo"
                className="max-w-full max-h-full object-contain"
              />
            </div>
            <div>
              <span className="text-xl font-heading font-bold text-foreground">Grid Balance</span>
              <p className="text-xs text-muted-foreground">Energy is the Key</p>
            </div>
          </div>
        </div>

        {/* Dealership Info - Bottom Section */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {dealership?.logo && (
              <div 
                className="w-32 h-32 rounded-lg overflow-hidden flex items-center justify-center border-2 border-border shadow-lg p-2"
                style={{ backgroundColor: dealership?.logoBackgroundColor || '#FFFFFF' }}
              >
                <Image
                  src={dealership?.logo}
                  alt={dealership?.logoAlt || `Logo von ${dealership?.name}`}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            )}
            <div>
              <h1 className="text-2xl font-heading font-bold text-foreground">
                {dealership?.name}
              </h1>
              <p className="text-sm text-muted-foreground flex items-center gap-2">
                <Icon name="MapPin" size={16} />
                {dealership?.street && dealership?.postalCode && dealership?.city ? (
                  <span>{dealership?.street}, {dealership?.postalCode} {dealership?.city}</span>
                ) : dealership?.city ? (
                  <span>{dealership?.city}</span>
                ) : null}
              </p>
            </div>
          </div>
          {dealership?.website && (
            <a
              href={dealership?.website}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-lg border border-border hover:bg-muted transition-smooth"
            >
              <Icon name="ExternalLink" size={16} />
              <span className="text-sm font-medium">Website besuchen</span>
            </a>
          )}
        </div>
      </div>
    </header>
  );
};

export default DealershipHeader;